import { useState } from "react";
import { UserPlus } from "lucide-react";

const field = "h-8 px-2 rounded-sm bg-slate-950 border border-slate-700 text-[12px] text-slate-100 focus:border-amber-400 outline-none";

export function NewClassInput({ onAdd, onCancel }) {
  const [name, setName] = useState("");
  const ok = name.trim().length > 0;
  return (
    <div className="flex gap-1" data-testid="assign-new-class-form">
      <input autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="New class name"
        onKeyDown={(e) => { if (e.key === "Enter" && ok) onAdd(name.trim()); if (e.key === "Escape") { e.stopPropagation(); onCancel(); } }}
        className={`${field} flex-1 min-w-0`} data-testid="assign-new-class-input" />
      <button type="button" disabled={!ok} onClick={() => onAdd(name.trim())} data-testid="assign-new-class-save"
        className="h-8 px-2.5 rounded-sm bg-amber-400 text-slate-950 text-[10px] font-bold uppercase tracking-widest disabled:opacity-40">Add</button>
    </div>
  );
}

export function NewPersonForm({ room, busy, onSave }) {
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [staff, setStaff] = useState(false);
  const ok = first.trim() && last.trim() && !busy;
  const save = () => ok && onSave({ first: first.trim(), last: last.trim(), is_staff: staff });
  return (
    <div className="border border-dashed border-slate-700 rounded-sm p-2 space-y-1.5" data-testid="assign-new-person-form">
      <p className="text-[10px] uppercase tracking-widest text-slate-400">Add person to <span className="text-amber-200">{room}</span></p>
      <div className="flex gap-1">
        <input value={first} onChange={(e) => setFirst(e.target.value)} placeholder="First name" onKeyDown={(e) => e.key === "Enter" && save()}
          className={`${field} flex-1 min-w-0`} data-testid="assign-new-first" />
        <input value={last} onChange={(e) => setLast(e.target.value)} placeholder="Last name" onKeyDown={(e) => e.key === "Enter" && save()}
          className={`${field} flex-1 min-w-0`} data-testid="assign-new-last" />
      </div>
      <div className="flex items-center justify-between">
        <label className="inline-flex items-center gap-1.5 text-[11px] text-slate-300 cursor-pointer">
          <input type="checkbox" checked={staff} onChange={(e) => setStaff(e.target.checked)} className="accent-amber-400" data-testid="assign-new-staff" />
          Staff
        </label>
        <button type="button" disabled={!ok} onClick={save} data-testid="assign-new-person-save"
          className="h-7 px-2.5 inline-flex items-center gap-1 rounded-sm bg-emerald-500 text-slate-950 text-[10px] font-bold uppercase tracking-widest disabled:opacity-40 hover:bg-emerald-400">
          <UserPlus className="h-3.5 w-3.5" />Add &amp; assign
        </button>
      </div>
    </div>
  );
}
